export default {
    setConfig: (context: any, payload: string): void => {
        context.commit('setConfig', payload);
    },
    setDefault: (context: any, payload: string): void => {
        context.commit('setDefault', payload);
    }
};
